import React, {useEffect, useState} from 'react';
import Wallet from "../components/Wallet";
import {useNavigate} from "react-router-dom";

const WalletPage = () => {
    const [showPage, setShowPage] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        if(token) {
            if(window.localStorage.getItem("needRegistration") === '1'){
                navigate('/register');
            }
            setShowPage(true)
        }
        else {
            navigate('/unauthorize', { replace: true });
        }

    }, []);
    return (
        <React.Fragment >
            {showPage ?
                <Wallet />
                : ''
            }
        </React.Fragment>
    );
};

export default WalletPage;